'use client';
import { ChevronDown } from '@good/icons';
import { ActionIcon, Group, Table as MantineTable, Popover } from '@mantine/core';
import { forwardRef } from 'react';
import { clx } from './clx';
import classes from './table.module.css';
import { ThSortWrapper } from './th-sort-wrapper';
export const GoodTableTh = forwardRef(({ sticky, children, direction, onSort, options, ...props }, ref) => {
    if (sticky !== undefined) {
        return (<GoodTableThSticky sticky={sticky} direction={direction} onSort={onSort} options={options} {...props} ref={ref}>
          {children}
        </GoodTableThSticky>);
    }
    return (<MantineTable.Th ref={ref} {...props} p={onSort ? 0 : props.p} bg={props.bg ?? 'var(--gray-bg)'} fw={600} fz='sm' tt='uppercase' className={clx(classes.tableTh, props.className)}>
        <Group justify='space-between' align='center' wrap='nowrap'>
          <ThSortWrapper direction={direction} onSort={onSort}>
            {children}
          </ThSortWrapper>
          {options && (<Popover>
              <Popover.Target>
                <ActionIcon variant='default' mr='md' size='sm' c='gray' fz={12}>
                  <ChevronDown />
                </ActionIcon>
              </Popover.Target>
              <Popover.Dropdown>{options}</Popover.Dropdown>
            </Popover>)}
        </Group>
      </MantineTable.Th>);
});
export const GoodTableThSticky = forwardRef(({ sticky, children, direction, onSort, options, ...props }, ref) => {
    const { placement = 'left', noShadow = false, offset = 0 } = typeof sticky === 'boolean' ? {} : sticky;
    return (<MantineTable.Th ref={ref} pos='sticky' left={placement === 'left' ? offset : undefined} right={placement === 'right' ? offset : undefined} data-placement={placement} {...props} p={onSort ? 0 : props.p} className={clx(classes.tableTh, 'stickyTh', !noShadow && 'stickyTh__scrollShadow', props.className)} style={{
            zIndex: 2,
            ...props.style,
        }} bg={props.bg ?? 'var(--gray-bg)'} fw={600} fz='sm' tt='uppercase'>
        <ThSortWrapper direction={direction} onSort={onSort}>
          <Group justify='space-between'>
            {children}
            {options && (<Popover>
                <Popover.Target>
                  <ActionIcon>
                    <ChevronDown />
                  </ActionIcon>
                </Popover.Target>
                <Popover.Dropdown>{options}</Popover.Dropdown>
              </Popover>)}
          </Group>
        </ThSortWrapper>
      </MantineTable.Th>);
});
